import { CSSObject } from '@chakra-ui/react';

export const LinkForgotPassword: CSSObject = {
  color: 'beta.400',
  fontSize: 'xs',
  fontWeight: 'medium',
};
